<template>
    <div class="d-flex justify-space-between align-center" style="max-height: 44px">
        <div @click="icon.includes('fxt-chevron') ? $emit('openDropdown') : null" :style="icon.includes('fxt-chevron') ? 'cursor: pointer' : ''">
            <v-icon v-if="icon != ''" :size="iconSize" color="primary" class="pr-2 pb-1">{{ icon }}</v-icon><span :class="icon == '' ? 'pl-9' : ''" class="toggle-item-title">{{ consentTitle(title) }}</span>
        </div>
        <v-checkbox
            background-color="transparent"
            :class="[subPadding ? 'pr-4' : '', indeterminate ? 'fixit-consents-checkbox-indeterminate' : '']"
            v-model="toggleState"
            :color="switchColor"
            :disabled="disabled"
            :indeterminate="indeterminate"
        ></v-checkbox>
    </div>
</template>
<script>
export default {
    name: "the-consent-toggle-item",
    props: {
        title: {
            required: true,
            default: ''
        },
        icon: {
            required: false,
            default: ''
        },
        iconSize: {
            required: false,
            default: '28px',
        },
        toggled: {
            required: true,
            default: false,
        },
        disabled: {
            required: false,
            default: false
        },
        switchColor: {
            required: false,
            default: '#579FA7' //Fixit color default
        },
        subPadding: {
            default: false,
            type: Boolean,
            required: false
        },
        indeterminate: {
            required: false,
            default: false,
            type: Boolean
        }
    },
    computed: {
        toggleState: {
            get() {
                return this.toggled.toggleState
            },
            set(val) {
                this.$emit('setState', {id: this.toggled.id, toggleState: val, parentDescription: this.toggled.parentDescription})
            }
        }
    },
    methods: {
        consentTitle(title) {
            if (title != 'SMS') {
                return title.charAt(0).toUpperCase() + title.slice(1).toLowerCase()
            } else {
                return title
            }
        }
    }
};
</script>
<style scoped>
.toggle-item-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
}
</style>